// LOADER ************************************************************************************
/*********************************************************************************************
 * Add a loading state to the specified button.
 *
 * @param {HTMLElement} elem - The element to which the 'mm-loading' class will be added.
 */
const mmLoadThis = (elem) => {
	elem.classList.add('mm-loading');
};
const mmLoadThem = (elems) => {
	elems.forEach(function (elem) {
		elem.classList.add('mm-loading');
	});
};
const mmStopLoadThem = (elems) => {
	elems.forEach(function (elem) {
		elem.classList.remove('mm-loading');
	});
};

// MEGAMENU **********************************************************************************
/*********************************************************************************************
 * Hide specified elements and show the specified element.
 *
 * @param {string} classElemsToHide - The CSS selector for the elements to hide.
 * @param {string} classElemToShow - The CSS selector for the element to show.
 */
const mmMegaMenuShowProducts = (classElemsToHide, classElemToShow) => {
	document.querySelectorAll(classElemsToHide).forEach((elem) => (elem.style.display = 'none'));
	document.querySelector(classElemToShow).style.display = 'grid';
};

/*********************************************************************************************
 * Adjust the position of the mega menu based on the header height.
 *
 */
const getMegaMenuPosition = () => {
	const header = document.querySelector('[data-mm-header]');
	if (!header) return;

	const headerHeight = header.offsetHeight;
	document.querySelectorAll('[data-megamenulink]').forEach((menuElem) => {
		const megaMenu = menuElem.nextElementSibling;
		if (megaMenu?.hasAttribute('data-megamenu')) {
			megaMenu.style.top = `${headerHeight}px`;
		}
	});
};

// BACKGROUND FILTER *************************************************************************
/*********************************************************************************************
 * Add background filter on hover over mega menu links.
 *
 */
const hoverBgFilter = () => {
	const header = document.querySelector('[data-mm-header]');
	const searchContainer = document.querySelector('[data-search-container]');
	const megaMenuLinks = document.querySelectorAll('[data-megamenulink]');
	const menuLinks = document.querySelectorAll('[data-menulink]');
	const filter = document.querySelector('[data-filter]');
	const cart = document.querySelector('[data-cart-filter]');

	if (!header || !filter || !cart) return;

	const toggleFilter = (show) => {
		filter.classList.toggle('active', show);
	};

	megaMenuLinks.forEach((link) => link.addEventListener('mouseenter', () => toggleFilter(true)));
	menuLinks.forEach((link) => link.addEventListener('mouseenter', () => toggleFilter(false)));

	header.addEventListener('mouseleave', () => {
		if (
			(!searchContainer || !searchContainer.classList.contains('mm-open')) &&
			!cart.classList.contains('mm-dc-is-open')
		) {
			toggleFilter(false);
		}
		// mmHideSearch();
	});
};

/*********************************************************************************************
 * Show background filter.
 *
 */
const showBgFilter = (zIndex) => {
	const filter = document.querySelector('[data-filter]');
	if (!filter) return;
	filter.classList.add('active');
	if (zIndex) filter.style.zIndex = zIndex;
};

/*********************************************************************************************
 * Hide background filter.
 *
 */
const hideBgFilter = () => {
	const filter = document.querySelector('[data-filter]');
	if (!filter) return;
	setTimeout(() => filter.style.removeProperty('z-index'), 700);
	filter.classList.remove('active');
};

// EXTERNAL LINK *****************************************************************************
/*********************************************************************************************
 * Open external links in a new tab unless it's the consent modale.
 *
 */
const externalLink = () => {
	document.querySelectorAll('a:not(.consent-wrapper)').forEach((link) => {
		if (link.hostname !== window.location.hostname) {
			link.target = '_blank';
			link.rel = 'noreferrer noopener';
		}
	});
};

// MENU MOBILE *******************************************************************************
/*********************************************************************************************
 * Toggle the mobile menu.
 *
 */
/**
 * Charge les images lazy du menu mobile en convertissant data-src en src
 * @param {HTMLElement} mobileMenu - L'élément menu mobile
 */
const loadMobileMenuImages = (mobileMenu) => {
	if (!mobileMenu) return;

	const images = mobileMenu.querySelectorAll('img[data-src]');
	images.forEach((img) => {
		if (img.dataset.src) {
			img.src = img.dataset.src;
			delete img.dataset.src;
		}
		if (img.dataset.srcset) {
			img.srcset = img.dataset.srcset;
			delete img.dataset.srcset;
		}
	});
};

const mmMobileMenu = () => {
	if (window.innerWidth > 990) return;

	const elements = {
		header: document.querySelector('header'),
		icon: document.querySelector('[data-header-burger]'),
		mobileMenu: document.querySelector('[data-menu-mobile]'),
		mobileMenuSecondary: document.querySelector('[data-menu-sublinks]'),
		headerMenu: document.querySelector('[data-mm-header]'),
		html: document.documentElement,
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { header, icon, mobileMenu, headerMenu, html } = elements;

	const headerMenuTop = headerMenu.getBoundingClientRect().top;
	const topPosition = `${headerMenuTop - 1}px`;
	const heightCalc = `calc(var(--doc-height) - ${topPosition})`;

	[header, icon, mobileMenu].forEach((el) => el.classList.toggle('mm-open'));

	Object.assign(mobileMenu.style, { top: topPosition, height: heightCalc });

	html.classList.add('stop-scrolling');

	showBgFilter('var(--index-lg)');

	// Charge les images uniquement à l'ouverture du menu
	if (mobileMenu.classList.contains('mm-open')) {
		loadMobileMenuImages(mobileMenu);
	}

	initMobileSplide();
};

/*********************************************************************************************
 * Close the mobile menu.
 *
 */
const mmCloseMobileMenu = (keepFilterActive = false) => {
	if (window.innerWidth > 990) return;

	const elements = {
		header: document.querySelector('header'),
		icon: document.querySelector('[data-header-burger]'),
		mobileMenu: document.querySelector('[data-menu-mobile]'),
		html: document.documentElement,
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { header, icon, mobileMenu, html } = elements;

	[header, icon, mobileMenu].forEach((el) => el.classList.remove('mm-open'));

	html.classList.remove('stop-scrolling');

	if (!keepFilterActive) hideBgFilter();
};

/*********************************************************************************************
 * Show the next sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
const mmMobileMenuShowNext = (elemToShowClass) => {
	document.querySelector(elemToShowClass)?.classList.add('mm-mobile-menu-elem-slided');
};

/*********************************************************************************************
 * Show the previous sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
const mmMobileMenuShowPrev = (elemToShowClass) => {
	document.querySelector(elemToShowClass)?.classList.remove('mm-mobile-menu-elem-slided');
};

// DROPDOWN **********************************************************************************
/*********************************************************************************************
 * Handle dropdown behavior.
 *
 */
const handleDropdown = () => {
	const dropWrappers = document.querySelectorAll('[data-drop="dropdown"]');

	dropWrappers.forEach((item) => {
		item.addEventListener('click', function () {
			dropWrappers.forEach((el) => {
				if (el !== this) {
					el.classList.remove('active');
					if (el.nextElementSibling) el.nextElementSibling.style.maxHeight = null;
				}
			});

			this.classList.toggle('active');
			const content = this.nextElementSibling;

			if (content) {
				content.style.maxHeight = this.classList.contains('active')
					? `${content.scrollHeight}px`
					: null;
			}
		});
	});
};

/*********************************************************************************************
 * Initialize the Instagram scroll effect.
 */
const mmInitInstagramScroll = () => {
	if (typeof gsap === 'undefined') {
		console.warn("GSAP n'est pas chargé");
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const container = document.querySelector('.mm-instagram-container');
	if (!container) return;

	const containerText = container.querySelector('.mm-instagram-text-container');

	// Configuration des états selon la taille d'écran
	const config = {
		desktop: {
			initial: [
				{
					top: '50%',
					left: '50%',
					zIndex: '1',
				},
				{
					top: '50%',
					right: '50%',
					zIndex: '3',
				},
				{
					top: '50%',
					right: '50%',
					zIndex: '5',
				},
				{
					bottom: '50%',
					right: '50%',
					zIndex: '4',
				},
				{
					bottom: '50%',
					right: '50%',
					zIndex: '2',
				},
			],
			final: [
				{
					top: '40%',
					left: '10%',
				},
				{
					top: '15%',
					right: '52%',
				},
				{
					top: '30%',
					right: '10%',
				},
				{
					bottom: '20%',
					right: '20%',
				},
				{
					bottom: '-60%',
					left: '0',
				},
			],
		},
		mobile: {
			initial: [
				{
					top: '50%',
					left: '50%',
					zIndex: '1',
				},
				{
					top: '50%',
					right: '50%',
					zIndex: '3',
				},
				{
					bottom: '50%',
					left: '50%',
					zIndex: '5',
				},
				{
					bottom: '50%',
					right: '50%',
					zIndex: '4',
				},
				{
					bottom: '50%',
					right: '50%',
					zIndex: '2',
				},
				{
					top: '50%',
					right: '50%',
					zIndex: '6',
				},
			],
			final: [
				{
					top: '20%',
					left: '20%',
				},
				{
					top: '20%',
					right: '20%',
				},
				{
					bottom: '20%',
					left: '20%',
				},
				{
					bottom: '20%',
					right: '20%',
				},
				{
					bottom: '20%',
					right: '20%',
				},
				{
					top: '20%',
					right: '20%',
				},
			],
		},
	};

	let instagramScrollTriggers = [];
	let mobileObserver = null;

	const createAnimation = () => {
		gsap.killTweensOf(Array.from(container.querySelectorAll('.mm-instagram-item')));
		instagramScrollTriggers.forEach((t) => t.kill());
		instagramScrollTriggers = [];
		if (mobileObserver) {
			mobileObserver.disconnect();
			mobileObserver = null;
		}

		const isDesktop = window.innerWidth >= 1024;
		const gridSelector = isDesktop ? '.mm-desktop-1024' : '.mm-mobile-1024';
		const currentConfig = isDesktop ? config.desktop : config.mobile;
		const currentItems = container.querySelectorAll(`${gridSelector} .mm-instagram-item`);

		if (isDesktop) {
			currentItems.forEach((item, index) => {
				if (!currentConfig.initial[index]) return;
				const tween = gsap.fromTo(item, currentConfig.initial[index], {
					...currentConfig.final[index],
					scrollTrigger: {
						trigger: containerText,
						start: 'center bottom',
						end: 'bottom center',
						scrub: 3,
					},
				});
				if (tween.scrollTrigger) instagramScrollTriggers.push(tween.scrollTrigger);
			});
		} else {
			currentItems.forEach((item, index) => {
				if (!currentConfig.initial[index]) return;
				gsap.set(item, currentConfig.initial[index]);
			});
			mobileObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						currentItems.forEach((item, index) => {
							if (!currentConfig.final[index]) return;
							gsap.to(item, {
								...currentConfig.final[index],
								duration: 0.8,
								ease: 'power2.out',
								delay: index * 0.1,
							});
						});
						mobileObserver.disconnect();
						mobileObserver = null;
					}
				});
			}, { threshold: 0.3 });
			mobileObserver.observe(containerText);
		}
	};

	// Créer l'animation initiale
	createAnimation();

	// Recréer l'animation uniquement si le breakpoint change (desktop ↔ mobile)
	let resizeTimeout;
	let currentBreakpoint = window.innerWidth >= 1024 ? 'desktop' : 'mobile';
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			const newBreakpoint = window.innerWidth >= 1024 ? 'desktop' : 'mobile';
			if (newBreakpoint !== currentBreakpoint) {
				currentBreakpoint = newBreakpoint;
				createAnimation();
			}
		}, 250);
	});
};

// Initialisation
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', mmInitInstagramScroll);
} else {
	mmInitInstagramScroll();
}

// SEARCH ************************************************************************************
/*********************************************************************************************
 * Show the search bar and related UI changes.
 *
 * @param {HTMLElement} clickedElem - The element that was clicked to show the search bar.
 */
const mmShowSearch = () => {
	const elements = {
		search: document.querySelector('[data-search-container]'),
		html: document.documentElement,
		searchInput: document.getElementById('Search'),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { search, html, searchInput } = elements;

	const searchFilter = document.querySelector('[data-search-container-filter]');

	html.classList.add('stop-scrolling');
	search.classList.add('mm-open');
	searchFilter.classList.add('mm-open');
	// showBgFilter();

	setTimeout(() => searchInput.focus(), 1000);

	document.getElementById('predictive-search')?.addEventListener('touchstart', () => {
		setTimeout(() => searchInput.blur(), 500);
	});
};

/*********************************************************************************************
 * Hide the search bar and revert UI changes.
 *
 * @param {HTMLElement} clickedElem - The element that was clicked to hide the search bar.
 */
const mmHideSearch = (keepFilterActive = false) => {
	const elements = {
		search: document.querySelector('[data-search-container]'),
		html: document.documentElement,
		searchInput: document.getElementById('Search'),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { search, html, searchInput } = elements;

	const searchFilter = document.querySelector('[data-search-container-filter]');

	if (search.classList.contains('mm-open')) {
		html.classList.remove('stop-scrolling');
	}
	search.classList.remove('mm-open');
	searchFilter.classList.remove('mm-open');

	searchInput.value = '';
	searchInput.dispatchEvent(new Event('input'));
};

/*********************************************************************************************
 * Search
 *
 */
const headerCenter = document.querySelector('.mm-header-center');
const headerLeft = document.querySelector('.mm-header-left');
const headerRightMenu = document.querySelector('.mm-header-secondary-menu');
const headerRightIcon = document.querySelector('.mm-header-icons');

if (headerCenter) {
	headerCenter.addEventListener('mouseenter', () => {
		mmHideSearch();
	});
}

if (headerLeft) {
	headerLeft.addEventListener('mouseenter', () => {
		mmHideSearch();
	});
}

if (headerRightMenu) {
	headerRightMenu.addEventListener('mouseenter', () => {
		mmHideSearch();
	});
}

if (headerRightIcon) {
	headerRightIcon.addEventListener('mouseenter', () => {
		mmHideSearch();
	});
}

/*********************************************************************************************
 * Initialize parallax effect for slide images.
 *
 */
const mmInitParallax = () => {
	const images = document.querySelectorAll('.mm-slide-image');
	if (!images.length) return;

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const slideImage = entry.target;
					const covers = slideImage.querySelectorAll('.mm-slide-image-cover');
					if (!covers.length) return;

					covers.forEach((cover) => {
						gsap.to(cover, {
							yPercent: 30,
							ease: 'none',
							scrollTrigger: {
								trigger: slideImage,
								start: 'top bottom',
								end: 'bottom top',
								scrub: true,
							},
						});
					});

					observer.unobserve(slideImage);
				}
			});
		},
		{
			rootMargin: '0px 0px 200px 0px',
		},
	);

	images.forEach((image) => observer.observe(image));
};

/*********************************************************************************************
 * Handles lazy loading of videos based on viewport size
 *
 */
const mmInitVideoLazy = () => {
	const videos = document.querySelectorAll('.mm-video-lazy');
	if (!videos.length) return;

	const loadVideo = (video) => {
		if (video.dataset.loaded !== 'true') {
			const source = video.querySelector('source');
			if (!source || !source.dataset.src) return;

			source.src = source.dataset.src;
			video.preload = 'metadata';
			video.dataset.loaded = 'true';

			video.load();
			video.play().catch((err) => console.warn('Auto-play failed:', err));
		}
	};

	const unloadVideo = (video) => {
		if (video.dataset.loaded === 'true') {
			video.pause();
			video.currentTime = 0;
			video.dataset.loaded = 'false';
		}
	};

	const handleVideoVisibility = (video) => {
		const isMobile = window.matchMedia('(max-width: 768px)').matches;
		const isDesktop = video.classList.contains('mm-desktop');
		const isMobileVideo = video.classList.contains('mm-mobile');

		const shouldPlay =
			(!isDesktop && !isMobileVideo) || (isDesktop && !isMobile) || (isMobileVideo && isMobile);

		if (shouldPlay) {
			loadVideo(video);
			video.classList.add('mm-video-loaded');
		} else {
			video.classList.remove('mm-video-loaded');
		}
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					handleVideoVisibility(entry.target);
				} else {
					unloadVideo(entry.target);
				}
			});
		},
		{
			rootMargin: '50px 0px',
			threshold: 0.1,
		},
	);

	videos.forEach((video) => observer.observe(video));

	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			videos.forEach((video) => {
				if (video.classList.contains('mm-video-loaded')) {
					handleVideoVisibility(video);
				}
			});
		}, 250);
	});
};

/*********************************************************************************************
 * Set the document height CSS variable to the current window height.
 *
 */
const documentHeight = () => {
	document.documentElement.style.setProperty('--doc-height', `${window.innerHeight}px`);
};

/*********************************************************************************************
 * Custom element for product recommendations
 *
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
						this.querySelectorAll('img[lazy-src], img[lazy-srcset]').forEach((img) => {
							const lazySrc = img.getAttribute('lazy-src');
							const lazySrcset = img.getAttribute('lazy-srcset');
							if (lazySrc) { img.setAttribute('src', lazySrc); img.removeAttribute('lazy-src'); }
							if (lazySrcset) { img.setAttribute('srcset', lazySrcset); img.removeAttribute('lazy-srcset'); }
						});
						// Réinitialiser la wishlist pour les nouvelles cartes de produits
						if (window.wishlistManager) {
							window.wishlistManager.initButtons();
						}
					} else {
						const parentElement = this.closest('.mm-section');
						if (parentElement) {
							parentElement.style.display = 'none';
						}
					}
				})
				.then(mmSetupSplideRecos)
				.then(mmSetupSplideRecentlyViewedCo)
				.then(startLenis)
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 400px 0px',
		}).observe(this);
	}
}

customElements.define('product-recommendations', ProductRecommendations);

/*********************************************************************************************
 * Code for store locator section
 *
 */
document.querySelectorAll('.mm-section-store-locator').forEach((element, index) => {
	element.classList.add(`mm-section-store-locator-${index + 1}`);
});

/*********************************************************************************************
 * Animation SVG Footer
 *
 */
// function animateSvgFill(selector, fillColor) {
//     if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
//         console.error("GSAP ou ScrollTrigger non chargé.");
//         return;
//     }

//     let isMobile = window.innerWidth < 768;

//     gsap.to(selector, {
//         fill: fillColor,
//         scrollTrigger: {
//             trigger: selector,
//             start: isMobile ? "25% bottom" : "top bottom",
//             end: isMobile ? "170% bottom" : "bottom bottom",
//             scrub: true,
//             // markers: true
//         }
//     });
// }
function animateSvgFill(selector, fillColor) {
	if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
		console.error('GSAP ou ScrollTrigger non chargé.');
		return;
	}

	let isMobile = window.innerWidth > 768;

	if (!isMobile) {
		// Ne rien faire si la largeur est supérieure ou égale à 768px
		return;
	}

	gsap.to(selector, {
		fill: fillColor,
		scrollTrigger: {
			trigger: selector,
			start: 'top bottom',
			end: 'bottom bottom',
			scrub: true,
			// markers: true
		},
	});
}

// DOM ***************************************************************************************
/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener('DOMContentLoaded', () => {
	getMegaMenuPosition();
	hoverBgFilter();
	externalLink();
	handleDropdown();
	documentHeight();
	mmInitParallax();
	mmInitVideoLazy();
	animateSvgFill('.mm-icon-text-rendel svg path', '#FFF');
});

/*********************************************************************************************
 * Resized Listenner
 *
 */
window.addEventListener('resize', () => {
	getMegaMenuPosition();
	documentHeight();
	animateSvgFill('.mm-icon-text-rendel svg path', '#FFF');
});

/* UTILITIES */
function toCapitalized(str) {
	return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
}

/* Accordions */
document.addEventListener('DOMContentLoaded', function () {
	if (window._initDejaFait) return;
	window._initDejaFait = true;
	const toggles = document.querySelectorAll('[data-accordion-toggle]');

	toggles.forEach((toggle) => {
		toggle.addEventListener('click', function () {
			const targetId = toggle.getAttribute('data-accordion-toggle');
			const content = document.querySelector(`[data-accordion-content="${targetId}"]`);

			if (!content) return;

			// Toggle class
			const isOpen = content.classList.contains('open');

			// Close all others
			document.querySelectorAll('[data-accordion-content]').forEach((el) => {
				el.classList.remove('open');
				el.style.height = null;
				el.style.maxHeight = null;
			});

			// Open the selected one if it was closed
			if (!isOpen) {
				content.classList.add('open');
				content.style.height = content.scrollHeight + 'px';
				content.style.maxHeight = content.scrollHeight + 'px';
			}
		});
	});

	const elemsToOpenOnLoad = document.querySelectorAll('[data-open-on-load]');
	elemsToOpenOnLoad.forEach(function (elem) {
		const clickEvent = new Event('click');
		elem.dispatchEvent(clickEvent);
	});
});

// PRODUCT CARDS
function mmChangeCardImage(spanElem) {
	const card = spanElem.closest('.mm-product-card');
	const main_image = card.querySelector('.mm-product-card-main-image');
	const hover_image = card.querySelector('.mm-product-card-image-hover');
	const image_wrapper = card.querySelector('.mm-product-card-image-wrapper');
	const main_video = card.querySelector('.mm-product-card-video-main');
	const hover_video = card.querySelector('.mm-product-card-video-hover');
	const spanElems = card.querySelectorAll('.mm-product-card-color-container');
	const links = card.querySelectorAll('a');

	spanElems.forEach(function (spanElem) {
		spanElem.classList.remove('mm-active');
	});
	spanElem.classList.add('mm-active');

	// Gestion des vidéos et images
	const videoUrl = spanElem.dataset.videoUrl;
	const videoAutoplay = spanElem.dataset.videoAutoplay === 'true';
	const imageUrl = spanElem.dataset.imageUrl;
	const secImageUrl = spanElem.dataset.secImageUrl;

	if (videoUrl) {
		// Le variant a une vidéo
		if (videoAutoplay) {
			// Mode autoplay : afficher la vidéo en main, masquer l'image main
			if (main_video) {
				main_video.dataset.videoSrc = videoUrl;
				main_video.style.display = 'block';
				mmLoadVideo(main_video, true);
			} else {
				// Créer la vidéo si elle n'existe pas
				const video = document.createElement('video');
				video.className = 'mm-product-card-video mm-product-card-video-main mm-lazy-video';
				video.autoplay = true;
				video.loop = true;
				video.muted = true;
				video.playsInline = true;
				video.preload = 'none';
				video.dataset.videoSrc = videoUrl;
				card.querySelector('.mm-filter-rainbow-collection').prepend(video);
				mmLoadVideo(video, true);
			}
			if (image_wrapper) image_wrapper.style.display = 'none';
			if (hover_video) hover_video.style.display = 'none';

			// Mettre à jour l'image hover seulement
			if (hover_image && secImageUrl) {
				hover_image.src = secImageUrl;
				hover_image.srcset = '';
			}
		} else {
			// Mode hover : afficher l'image en main, la vidéo en hover
			if (hover_video) {
				hover_video.dataset.videoSrc = videoUrl;
				hover_video.style.display = 'block';
				mmLoadVideo(hover_video);
			} else {
				// Créer la vidéo hover si elle n'existe pas
				const video = document.createElement('video');
				video.className = 'mm-product-card-video mm-product-card-video-hover mm-lazy-video';
				video.loop = true;
				video.muted = true;
				video.playsInline = true;
				video.preload = 'none';
				video.dataset.videoSrc = videoUrl;
				card.querySelector('.mm-product-card-image-container').appendChild(video);
				mmLoadVideo(video);
			}
			if (main_video) main_video.style.display = 'none';
			if (image_wrapper) image_wrapper.style.display = 'block';

			// Mettre à jour les images
			if (main_image && imageUrl) {
				main_image.src = imageUrl;
				main_image.srcset = '';
			}
			if (hover_image && secImageUrl) {
				hover_image.src = secImageUrl;
				hover_image.srcset = '';
			}
		}
	} else {
		// Pas de vidéo : mode image normal
		if (main_video) main_video.style.display = 'none';
		if (hover_video) hover_video.style.display = 'none';
		if (image_wrapper) image_wrapper.style.display = 'block';

		// Mettre à jour les images
		if (main_image && imageUrl) {
			main_image.src = imageUrl;
			main_image.srcset = '';
		}
		if (hover_image && secImageUrl) {
			hover_image.src = secImageUrl;
			hover_image.srcset = '';
		}
	}

	// Mise à jour des liens
	if (links) {
		links.forEach(function (link) {
			link.href = spanElem.dataset.url;
		});
	}
}

// Lazy loading des vidéos avec IntersectionObserver
function mmLoadVideo(video, shouldPlay) {
	const videoSrc = video.dataset.videoSrc;
	if (!videoSrc) return;

	const existingSource = video.querySelector('source');
	let needsReload = false;

	if (existingSource) {
		// Comparer les URLs (gérer les URLs absolues vs relatives)
		const currentSrc = new URL(existingSource.src, window.location.origin).href;
		const newSrc = new URL(videoSrc, window.location.origin).href;

		if (currentSrc !== newSrc) {
			existingSource.src = videoSrc;
			needsReload = true;
		}
	} else {
		// Créer la source si elle n'existe pas
		const source = document.createElement('source');
		source.src = videoSrc;
		source.type = 'video/mp4';
		video.appendChild(source);
		needsReload = true;
	}

	if (needsReload) {
		video.load();
		// Si la vidéo doit jouer automatiquement (mode autoplay)
		if (shouldPlay || video.autoplay) {
			video.play().catch(function () {
				// Ignore les erreurs de play (peut arriver si l'utilisateur n'a pas interagi)
			});
		}
	}
}

// Observer pour lazy load des vidéos au scroll
const mmVideoObserver = new IntersectionObserver(
	function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				const video = entry.target;
				mmLoadVideo(video);
				mmVideoObserver.unobserve(video);
			}
		});
	},
	{
		rootMargin: '50px',
	}
);

// Initialiser les vidéos (observer + événements hover)
function mmInitializeProductVideos() {
	// Observer toutes les vidéos lazy
	const lazyVideos = document.querySelectorAll('.mm-lazy-video');
	lazyVideos.forEach(function (video) {
		mmVideoObserver.observe(video);
	});

	// Gérer le hover pour les vidéos hover
	const productCards = document.querySelectorAll('.mm-product-card');
	productCards.forEach(function (card) {
		const imageContainer = card.querySelector('.mm-product-card-image-container');
		const hoverVideo = card.querySelector('.mm-product-card-video-hover');

		if (imageContainer && hoverVideo) {
			// Vérifier si les événements ne sont pas déjà attachés
			if (!imageContainer.dataset.videoEventsAttached) {
				imageContainer.dataset.videoEventsAttached = 'true';

				imageContainer.addEventListener('mouseenter', function () {
					if (hoverVideo.style.display !== 'none' && hoverVideo.querySelector('source')) {
						hoverVideo.play();
					}
				});

				imageContainer.addEventListener('mouseleave', function () {
					if (hoverVideo.style.display !== 'none') {
						hoverVideo.pause();
						hoverVideo.currentTime = 0;
					}
				});
			}
		}
	});
}

// Initialiser au chargement de la page
document.addEventListener('DOMContentLoaded', function () {
	mmInitializeProductVideos();
});

// Réinitialiser après filtrage de la collection
document.addEventListener('reloadLazyLoad', function () {
	mmInitializeProductVideos();
});
